import { createSlice } from "@reduxjs/toolkit";
import {
  addSaga,
  createAsyncSaga,
  createSagaReducer,
  persist,
  sagaSlice,
} from "./sagaStore";
import shopKycService from "../services/allKycEntries";

const initialState: any = {
  list: {
    loading: false,
    error: null,
    data: {},
  },
  isKycPresent: false,
  shopName: null,
  category: null,
  pincode: null,
  created_at: null,
  updated_at: null,
  allShops: [],
  shopId: null,
  isFilterApplied: false,
  currentPage: 1,
  isActive: null,
};

const Slice: sagaSlice = createSlice({
  ...persist("allShopKycManagement", initialState),
  reducers: {
    ...createSagaReducer("fetchAllKycShops", "list"),
    updateKycPresent(state, action) {
      state.isKycPresent = action.payload;
    },
    updateShopName(state, action) {
      state.shopName = action.payload;
    },
    updateShopCategory(state, action) {
      state.category = action.payload;
    },
    updateShopPincode(state, action) {
      state.pincode = action.payload;
    },
    updateCreatedAt(state, action) {
      state.created_at = action.payload;
    },
    updateUpdatedAt(state, action) {
      state.updated_at = action.payload;
    },
    updateAllShops(state, action) {
      state.allShops = action.payload;
    },
    updateShopId(state, action) {
      state.shopId = action.payload;
    },
    updateFilterButton(state, action) {
      state.isFilterApplied = action.payload;
    },
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    setIsActive(state, action) {
      state.isActive = action.payload;
    },
  },
});

const fetchAllKycShopsData = createAsyncSaga(
  "fetchAllKycShops",
  Slice,
  shopKycService.fetchAllKycShops,
  [
    "currentPage",
    "itemsPerPage",
    "isKycPresent",
    "shopName",
    "category",
    "pincode",
    "isActive",
    "created_at",
    "updated_at",
  ]
);

addSaga(Slice.actions.fetchAllKycShops.type, fetchAllKycShopsData);

export const {
  fetchAllKycShops,
  updateKycPresent,
  updateShopName,
  updateShopCategory,
  updateShopPincode,
  updateCreatedAt,
  updateUpdatedAt,
  updateAllShops,
  updateShopId,
  updateFilterButton,
  setCurrentPage,
  setIsActive,
} = Slice.actions;

export default Slice.reducer;
